import { MatDialogConfig } from '@angular/material/dialog';
import { CREATE_ORDER_PANEL_CLASS } from 'src/features/service-order/create-order/ui/create-order/create-order-dialog.config';
import { EditScheduledPaymentDateDialogData } from './dialog-edit-fecha-pago-programada.component';

export function buildEditFechaPagoDialogConfig(
  data: EditScheduledPaymentDateDialogData
): MatDialogConfig<EditScheduledPaymentDateDialogData> {
  return {
    width: '420px',
    maxWidth: '94vw',
    panelClass: CREATE_ORDER_PANEL_CLASS,
    autoFocus: false,
    data
  };
}
